import React from "react";
import "./style.css";

const ContactReportModal = (props) => {
  return (
    <div id="Category-Personalize-Modal">
      <div className="contact-modal">
        <React.Fragment>
          <div className="header">
            <h2>{props.modalText}</h2>
          </div>
        </React.Fragment>
      </div>
    </div>
  );
};

export default ContactReportModal;
